import { ru } from "./ru/translation";
import { ua } from "./ua/translation";

export default { ua, ru };
